<header class="header">
  <div class="header__container">
    <a href="/" class="header__logo">
      <div class="header__logo-wrapper">
        <div class="header__logo-image"></div>
        <div class="header__navigation-line"></div>
      </div>
    </a>

    <nav class="header__navigation header__navigation-links">
      @for (item of menuItems; track $index) {
        <a class="header__navigation-item" (click)="onNavigateToItem(item)">
          {{ item.label | translate }}
        </a>
      }
    </nav>

    <ul class="header__navigation header__navigation-actions">
      <li class="header__navigation-action">
        <ui-button appereance="stroked" size="m" [label]="'general.signIn' | translate" (click)="navigateToSignIn()" />
      </li>

      <li class="header__navigation-action">
        <ui-button appereance="flat" size="m" [label]="'general.getStarted' | translate" (click)="navigateToSignUp()" />
      </li>

      <li class="header__navigation-action">
        <ui-select isLanguageSelector [formControl]="languageControl" [items]="languages" size="sm" />
      </li>
    </ul>
    <rp-home-menu-burger class="header__burger-menu" (click)="onToggleMobileMenu()" />
  </div>
</header>
